<template>

    <div class="row">
        <div class="col-md-6 col-md-offset-3">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">{{ showActiveUsers ? 'A' : 'Ina' }}ctieve gebruikers</h2>
                    <div class="box-tools">
                        <button class="btn btn-flat" type="button" @click="showActiveUsers = !showActiveUsers">
                            {{ !showActiveUsers ? 'A' : 'Ina' }}ctieve gebruikers
                        </button>
                        <router-link
                            class="btn btn-primary btn-xs"
                            :to="{name:'hr.users.add'}"
                            v-tooltip.bottom="'Gebruiker toevoegen'"
                        >
                            <i class="mdi mdi-plus"></i>
                            <span class="sr-only">Gebruiker toevoegen</span>
                        </router-link>
                    </div>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Naam</th>
                                <th>Gebruikersnaam</th>
                                <th>Laatste urenregistratie</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="getUsers.length === 0">
                                <td colspan="4">Er zijn geen gebruikers gevonden</td>
                            </tr>
                            <tr
                                v-for="user in getUsers"
                                :key="'user-' + user.uuid"
                            >
                                <td>{{ user.fullname }}</td>
                                <td>{{ user.username }}</td>
                                <td>{{ user.last_timeregistration_date }}</td>
                                <td class="text-right">
                                    <div class="btn-group btn-group-xs">
                                        <router-link
                                            class="btn btn-default"
                                            :to="{name:'hr.users.show',params:{uuid:user.uuid}}"
                                            v-tooltip="'Gebruiker bekijken'"
                                        >
                                            <i class="mdi mdi-eye"></i>
                                        </router-link>
                                        <router-link
                                            class="btn btn-primary"
                                            :to="{name:'hr.users.edit',params:{uuid:user.uuid}}"
                                            v-tooltip="'Gebruiker bewerken'"
                                        >
                                            <i class="mdi mdi-pencil"></i>
                                        </router-link>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="overlay" v-show="loading">
                    <i class="fa fa-refresh fa-spin"></i>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import axios from 'axios';

    export default {

        computed: {
            getUsers() {
                return this.users.filter(user => user.active === this.showActiveUsers);
            },
        },

        data() {
            return {
                loading:true,
                users:[],
                showActiveUsers:true,
            }
        },

        metaInfo: {
            title:'Users',
        },

        methods: {
            getData() {
                axios.get(this.route('api.v1.hr.users.index'))
                    .then(resp => {
                        this.users = resp.data.data;
                        this.loading = false;
                    });
            },
        },

        mounted(){
            this.getData();
        },

        name:'HrUsersIndex',

    }

</script>
